/**
 * Switch — controlled on/off toggle (Notion-style pill). Distinct from the
 * collapsible `Toggle` disclosure. Use for boolean preferences.
 */
export function Switch({ checked, onCheckedChange, disabled = false, className = '', id, ...rest }) {
  const cls = ['switch', checked ? 'on' : '', className].filter(Boolean).join(' ')
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      disabled={disabled}
      className={cls}
      onClick={() => onCheckedChange?.(!checked)}
      {...rest}
    >
      <span className="switch-thumb" />
    </button>
  )
}
